import { apiDelete } from "../../../api/fetch";
import { getReservationKeyFromPath } from "../../../components/Utils";
import { endpoints } from "../../../utils/Constants";
import useModal from "../../../hooks/useModal";
import { useNavigationGuard } from "./useNavigationGuard";

interface GuardEntry {
  selector: string;
  condition?: () => boolean;
}

interface UseLeaveGuardParams {
  showTimer: boolean;
  expirationModalOpen: boolean;
  playUrl: string;
  onBeforeOpen: () => void;
  suppressSelector?: string;
  guardEntries?: GuardEntry[];
  isSuppressed?: boolean;
}

export function useLeaveGuard({
  showTimer,
  expirationModalOpen,
  playUrl,
  onBeforeOpen,
  suppressSelector,
  guardEntries,
  isSuppressed,
}: UseLeaveGuardParams) {
  const {
    isOpen: isLeaveModalOpen,
    openModal: openLeaveModal,
    closeModal: closeLeaveModal,
  } = useModal(false, { disableScrollLock: true });

  const { markAsLeaving, pendingHrefRef } = useNavigationGuard({
    isActive: showTimer && !expirationModalOpen,
    onTrigger: () => {
      onBeforeOpen();
      openLeaveModal();
    },
    skipSelector: "[href*='Challenge.aspx'], #UserLoginBtn",
    suppressSelector,
    guardEntries,
    isSuppressed,
  });

  const handleLeave = () => {
    markAsLeaving();
    const requestKey = getReservationKeyFromPath();
    if (requestKey) {
      apiDelete(endpoints.reservation.getReservation(requestKey), {
        keepalive: true,
      }).catch(() => {});
    }
    window.location.href = pendingHrefRef.current ?? playUrl;
  };

  return { isLeaveModalOpen, closeLeaveModal, handleLeave, markAsLeaving };
}
